import { createActionGroup, props } from '@ngrx/store';
import { HomeScenario } from './scenarios.interface';

export const ScenariosActions = createActionGroup({
  source: 'Scenarios',
  events: {
    'Get scenarios': props<{ homeId: string, deviceTypes?: string[], filter?: string[] }>(),
    'Get scenarios success': props<{ home: HomeScenario }>(),
    'Get scenarios failure': props<{ payload }>(),
    'Set scenarios': props<{ params }>(),
    'Set scenarios success': props<{ home }>(),
    'Set scenarios failure': props<{ payload }>(),
  },
});

export type ScenariosActionUnion = ReturnType<typeof ScenariosActions[keyof typeof ScenariosActions]>;

export type GetScenariosAction = ReturnType<typeof ScenariosActions.getScenarios>;
export type GetScenariosSuccessAction = ReturnType<typeof ScenariosActions.getScenariosSuccess>;
export type GetScenariosFailureAction = ReturnType<typeof ScenariosActions.getScenariosFailure>;
export type SetScenariosAction = ReturnType<typeof ScenariosActions.setScenarios>;
export type SetScenariosSuccessAction = ReturnType<typeof ScenariosActions.setScenariosSuccess>;
export type SetScenariosFailureAction = ReturnType<typeof ScenariosActions.setScenariosFailure>;
